import * as React from "react"
import { Helmet } from "react-helmet"
import Header from '../components/Header'
import Footer from '../components/Footer'

export default () => {
  return (
    <main className="privacypage">
      <Helmet>
        <title>Privacy Policy - MOP Floorcheck</title>
        <link rel="canonical" href="https://mopfloorcheck.com/privacy-policy" />
      </Helmet>
      <Header tab="privacy" />
      
      <section className="intro">
        <div className="intro-content">
          <h2>PRIVACY NOTICE</h2>
          <hr />
          <p>Vehicle Audit & Floor Check Services</p>
        </div>
      </section>

      <section className="infobox-section">
        <div className="container">
          <div className="infobox">
            <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-GB')}</p>
            <p>Mop Floor Check ("we," "us") provides auditing and inventory verification services for financial institutions and automotive dealerships. In the course of these professional services, we process data related to vehicles.</p>
            
            <h3>1. Why we process data</h3>
            <p>We process vehicle data to verify the presence, registration status, and ownership of inventory for our clients (banks and dealerships). This is necessary to ensure the security of collateral and the accuracy of financial audits.</p>
            
            <h3>2. Data Sources</h3>
            <p>We receive data from two primary sources:</p>
            <ul>
              <li><strong>Our Clients:</strong> Inventory lists provided by the bank or dealership.</li>
              <li><strong>Official Registers:</strong> We retrieve vehicle registration and ownership status directly from <strong>Traficom (The Finnish Transport and Communications Agency)</strong> via their technical interface.</li>
            </ul>

            <h3>3. Categories of Data Processed</h3>
            <p>To perform our audits, we process:</p>
            <ul>
              <li>Technical vehicle data (VIN, Plate, Make/Model).</li>
              <li>Registration status.</li>
              <li>Ownership status (to verify if a vehicle has been sold and should be removed from a floor plan).</li>
            </ul>

            <h3>4. Legal Basis</h3>
            <p>We process this data based on <strong>GDPR Article 6(1)(f) - Legitimate Interest</strong>. We have a legitimate interest in providing accurate auditing services to ensure the financial integrity of the automotive supply chain.</p>

            <h3>5. Data Retention</h3>
            <p>Personal data retrieved from official registers is not kept longer than is necessary for the audit report's completion. We do not build long-term databases of private individuals.</p>

            <h3>6. Your Rights</h3>
            <p>Data subjects have the right to request access to their data, rectification, or erasure. Inquiries can be sent to: <a href="mailto:floorcheck@mop.dk">floorcheck@mop.dk</a>.</p>
          </div>
        </div>
      </section>
      
      <Footer />
    </main>
  )
}